import React from 'react';
import { Component } from 'react';
import { connect } from 'redux-scaffolding-ts';
import { WithTranslation, withTranslation } from 'react-i18next';
import { IdentityService } from 'services/identity-service';
import { resolve } from 'inversify-react';
import { replaceAll } from 'utils/useful-functions';
import { ToastComponent } from 'site/pages/landing-pages/util/toast-component';
import { ChangeRequestStore, RequestDto, RequestStatus } from 'stores/requests/requests-store';

interface SendRequestButtonTailwindProps extends WithTranslation {
  requestId: string;
  requestStatus: RequestStatus;
  requestCreatorRoles: string[];
  changeRequestStore?: ChangeRequestStore;
  readOnly: boolean;
  onBeginSend?: () => void;
  onSuccess?: (request: RequestDto) => void;
  onError?: () => void;
}

@connect(['changeRequestStore', ChangeRequestStore])
class SendRequestButtonTailwind extends Component<SendRequestButtonTailwindProps> {
  @resolve(IdentityService)
  private identityService: IdentityService;

  handleOnClick() {
    if (this.props.onBeginSend) this.props.onBeginSend();
    this.props.changeRequestStore
      .changeStatus(this.props.requestId, RequestStatus.Pending)
      .then(x => {
        this.props.onSuccess && this.props.onSuccess(x);
        this.props.onSuccess && ToastComponent({ text: this.props.t('Send Request successfully!'), type: 'success-toast' });
      })
      .catch(() => {
        this.props.onError && this.props.onError();
        this.props.changeRequestStore.state.result.messages.forEach(msg => ToastComponent({ text: msg.body, type: 'warning-toast' }));
      });
  }

  render() {
    const { t, readOnly } = this.props as any;
    return (
      this.isVisible() && (
        <button
          type="button"
          className={`flex-1 py-2 rounded border 
          ${!readOnly ? 'border-gray-200 text-gray-400' : 'border-gray-400 text-gray-800'}
           font-semibold hover:bg-gray-100 transition-all text-sm`}
          onClick={() => this.handleOnClick()}
          style={{ minWidth: 0 }}
          disabled={!readOnly}
        >
          {t('Send')}
        </button>
      )
    );
  }

  private isVisible(): boolean {
    return this.props.requestStatus.toString() === 'Draft' && this.currentUserHasPermission();
  }

  private currentUserHasPermission(): boolean {
    const userInfo = this.identityService.getUserInfo();

    if (IdentityService.isAdmin(userInfo)) return true;
    if (IdentityService.isReporting(userInfo)) return false;

    return (this.props.requestCreatorRoles || []).includes(replaceAll(userInfo.activeRole, ' ', ''));
  }
}

export default withTranslation()(SendRequestButtonTailwind);
